import type { EntityConfig } from '../types'

export const inventoryEntity: EntityConfig = {
  id: 'inventory',
  displayName: 'Inventory',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'in_stock', label: 'In Stock' },
      { value: 'low_stock', label: 'Low Stock' },
      { value: 'out_of_stock', label: 'Out of Stock' },
      { value: 'ordered', label: 'Ordered' },
    ],
    options: [
      { value: 'in_stock', label: 'In Stock', color: 'success' },
      { value: 'low_stock', label: 'Low Stock', color: 'warning' },
      { value: 'out_of_stock', label: 'Out of Stock', color: 'error' },
      { value: 'ordered', label: 'Ordered', color: 'pending' },
    ],
    mappings: {
      all: ['in_stock', 'low_stock', 'out_of_stock', 'ordered'],
      in_stock: ['in_stock'],
      low_stock: ['low_stock'],
      out_of_stock: ['out_of_stock'],
      ordered: ['ordered'],
    }
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    model: { type: 'string_array', urlKey: 'model' },
    store: { type: 'string_array', urlKey: 'store' },
    orderedDate: { type: 'date_range', urlKey: 'orderedDate' },
    fulfilledDate: { type: 'date_range', urlKey: 'fulfilledDate' },
    movedDate: { type: 'date_range', urlKey: 'movedDate' },
    search: { type: 'search', urlKey: '$s' }
  },
  uiFilterFields: [
    'search',
    'model',
    'store',
    'orderedDate',
    'fulfilledDate',
    'movedDate',
  ]
}
